import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppState, ShowRequest} from '../../core';

import { PostProcessingService, PostProcessingRestClient } from '../../core/services';
import { TableViewComponentBase, TableViewQueryCriteria, TableViewQueryRequest, TableViewQueryResponse } from '../../shared/components/table-view/table-view-component-base';
import { MissingHandsetTableCellComponent } from './missing-handset-table-cell.component';
import { MissingHandset } from '../../core/models/missing-handset';


@Component({
  selector: 'app-missing-handset-table',
  templateUrl: '../../shared/components/table-view/table-view.component.html',
  styleUrls: [
    '../../shared/components/table-view/scss/table-view.scss',
    '../../shared/components/table-view/scss/app-tab-full-height.scss',
    '../../shared/components/table-view/scss/fixed-headers-and-column.scss'
  ]
})
export class MissingHandsetTableComponent extends TableViewComponentBase<MissingHandset> implements OnInit, OnDestroy {

  protected restClient : PostProcessingRestClient

  constructor(
      appState: AppState,
      modalService: BsModalService,
      public postProcessingService: PostProcessingService,
      elementRef: ElementRef,
      datePipe: DatePipe
  ){
    super(appState,modalService,elementRef,datePipe)
    this.restClient = this.postProcessingService.httpClient
    this.tableCellRenderer = MissingHandsetTableCellComponent
    this.tableColumns  = [
      { title:'Stage', name: 'stage', visible: true},
      { title:'Building', name: 'buildingid', visible: true},
      { title:'Phone MAC', name: 'phonemac', visible: true},
      //{ title:'Carrier', name: 'carrier', visible: true},
      //{ title:'Make', name: 'make', visible: true},
      //{ title:'Model Name', name: 'modelname', visible: true},
      { title:'First Seen', name: 'firstseen', visible: true, template: 'time'},
      { title:'Last Seen', name: 'lastseen', visible: true, template: 'time'},
    ]
  }


  ngOnInit(): void {
    this.init()
  }


  ngOnDestroy(): void {
    this.destroy()
  }

  showMissing() {
    this.showTabFn( new ShowRequest('tab', 'missing handsets', null, null))
  }

  doQuery = async ( queryReq:TableViewQueryRequest ) => this.findMissingHandsets(queryReq)

  async findMissingHandsets( queryCriteria : TableViewQueryCriteria = null ) {
    try {
        const result : any = await this.restClient.http.get(
            `${this.restClient.urlPath}/missingHandset/find`, { params: {criteria: JSON.stringify(queryCriteria||{}) }}).toPromise()
        const resp : TableViewQueryResponse<MissingHandset> = result.data
        return resp
    } catch (error) {
        console.error('findMissingHandsets() error: ' + error?.message )
        throw error
    }
}

}
